import React from 'react';
import { Tabs, Tab } from '@mui/material';
import * as COLOR from '../../../../../constants/colors';
import { FAQTabsProps } from '../types';

export const FAQTabs: React.FC<FAQTabsProps> = ({ tabs, selectedTab, onTabChange }) => {
  return (
    <Tabs
      value={selectedTab}
      onChange={onTabChange}
      aria-label="FAQ tabs"
      sx={{
        "& .MuiTab-root": {
          fontSize: 18,
          fontWeight: 500,
          textTransform: "none",
          minWidth: "auto",
          px: 2,
          py: 1,
          color: COLOR.GREY3,
          transition: "color 0.2s ease",
          "&:hover": {
            color: COLOR.GREY1,
          },
        },
        "& .Mui-selected": {
          color: `${COLOR.COLOR_SECONDARY} !important`,
          borderBottom: `2px solid ${COLOR.COLOR_SECONDARY}`,
          "&:hover": {
            color: `${COLOR.COLOR_SECONDARY} !important`,
          },
        },
        "& .MuiTabs-indicator": {
          backgroundColor: COLOR.COLOR_SECONDARY,
        },
      }}
    >
      {tabs.map((tab) => (
        <Tab 
          key={tab.value} 
          label={tab.label}
          id={`faq-tab-${tab.value}`}
          aria-controls={`faq-tabpanel-${tab.value}`}
        />
      ))}
    </Tabs>
  );
};
